import React from "react";
import { Grid, Stack } from "@mui/material";
import { ReviewItem } from "../../clinics/Management/EnrollClinic/ReviewInformation";
import { renderField } from "../../patient/PatientDemographicsForm";

export function EditableReviewItem({
  label,
  value,
  edit = false,
  custom,
  prefix,
  control,
  errors,
  getLabel,
  getInputProps,
  handleRetrieve,
  watch
}) {
  let isFullWidth =
    label === "Permission" || label === "Address" || (label === "Comment" && value?.length > 40);

  if (custom.kind === 'clinic' && !edit) {
    return null;
  }

  if(custom.kind === 'clinic') {
    isFullWidth = true;
  }

  return (
    <Grid item md={isFullWidth ? 12 : 6} xs={12}>
      <Stack direction="column" sx={{ py: 1 }}>
        {edit ? (
          <Grid item>
            {
              renderField(custom, prefix, control, errors, getLabel, getInputProps, handleRetrieve, watch)
            }
          </Grid>
        ) : (
            <ReviewItem label={label} value={value} isFullWidthTrue={true} />
        )}
      </Stack>
    </Grid>
  );
}
